module.exports = __webpack_public_path__ + "static/img/pfriemsters-CellarClub.796035b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pfriemsters-CellarClub.png
// module id = 301
// module chunks = 1